import { useMutation } from '@tanstack/react-query';
import { AuthOtpPinService, SendOtpDto, SendOtpEntity } from 'services/openapi';

export const useOtpPinSendOtp = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<SendOtpEntity, Error, SendOtpDto>({
      mutationFn: (variables: SendOtpDto) => {
        return AuthOtpPinService.otpPinControllerSendOtp(variables);
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
